import { DEFAULT_GAME_SEASON, isSeason, type Season } from './season';
import type { SeasonPackage } from './types';

const loaders: Record<Season, () => Promise<SeasonPackage>> = {
  alpine: () => import('./alpine').then(({ alpine }) => alpine),
  candy: () => import('./candy').then(({ candy }) => candy),
  egypt: () => import('./egypt').then(({ egypt }) => egypt),
  halloween: () => import('./halloween').then(({ halloween }) => halloween),
  'cherry-blossom': () => import('./cherry-blossom').then(({ cherryBlossom }) => cherryBlossom),
  pixel: () => import('./pixel').then(({ pixel }) => pixel),
  winter: () => import('./winter').then(({ winter }) => winter),
};
const pending = new Map<Season, Promise<SeasonPackage>>();

/** Selected and explicitly prefetched packages share one download; failures can be retried. */
export function loadSeason(season: Season): Promise<SeasonPackage> {
  // Also cover saved games/drafts and direct callers while Candy is disabled.
  if (!isSeason(season)) season = DEFAULT_GAME_SEASON;
  const existing = pending.get(season);
  if (existing) return existing;
  const result = loaders[season]().catch((error: unknown) => {
    pending.delete(season);
    throw error;
  });
  pending.set(season, result);
  return result;
}
